// removed by extract-text-webpack-plugin
module.exports = {"agSidePanel":"_1AP6HRITh7YYWp0gvtVjRJ","visiblePanelPart":"_3OOhJlhkKuV8vQfYPQilcA","agPanelBody":"_3cVHof-ez7USra68dz3Sre","left":"_1nlQuA7wcFTx_7q9cp2t9h","right":"D3_RnT3KRZ8RwBbEnGq8A","top":"_1VdbAQuHmhmYPaFliYHSgb","pushed":"_2xgKElcHaQ-L0P5Em0oFyX","semiPushed":"_2c7AJKalMEHgTT3Mj4_uAC","visible":"_20zEsZHYh7K3Z9AUhlP7Ie","sub":"ekO3Rpl6kBpOxzkn4akWn","onePanel":"_1r_AUk7CYtMYmg7OwS3he5","deeper-menu":"_3q66CV6ejlOD63P6o8wct4","agPanelIcons":"_3X02SK4i54DfmmwC4Ka1WW","top-menu":"_1ifQZ-IynSV1k4MXvU0NeJ","main-menu":"_3cbBhP2kvTBqfnZsEkWCBB","menu-item":"_1OEk3emDkbmSd06tTzOxmy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SidePanel/SidePanel.scss
// module id = 825
// module chunks = 0